(() => {
  if (customElements.get('croma-announcement')) return;
  customElements.define('croma-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.marquee !== 'true' || !window.ResizeObserver) return;
      this.track = this.querySelector('.croma-announcement__track');
      this.group = this.track?.firstElementChild;
      this.item = this.group?.firstElementChild?.cloneNode(true);
      if (!this.item) return;
      // Decorative copies remain clickable, but keyboard navigation uses the original text.
      this.item.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      this.controller = new AbortController();
      this.querySelector('button').addEventListener('click', () => {
        const paused = this.classList.toggle('is-paused');
        this.querySelector('button').setAttribute('aria-pressed', String(paused));
      }, { signal: this.controller.signal });
      this.observer = new ResizeObserver(() => this.build());
      this.observer.observe(this.querySelector('.croma-announcement__viewport'));
      document.fonts.ready.then(() => { if (this.isConnected) this.build(); });
      this.build();
    }
    build() {
      this.classList.add('is-ready');
      this.group.replaceChildren(this.item.cloneNode(true));
      while (this.track.children.length > 1) this.track.lastElementChild.remove();
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      const count = Math.ceil(this.querySelector('.croma-announcement__viewport').clientWidth / width) + 1;
      for (let i = 1; i < count; i++) this.group.append(this.item.cloneNode(true));
      this.track.append(this.group.cloneNode(true));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
  });
})();
